const reservas = {
  lastModified: '2018-08-01T21:24:42+00:00',
  list: [
    {
      id: 7465,
      fila: 1,
      status: -1,
      data_reserva: '2018-08-11T00:00:00-03:00',
      motivo: 'Desistencia da festa',
      unidade: '2202',
      reservado_por: 'cond\u00f4mino',
      email_reserva: 'thiago.igor.oliveira@gmail.com',
      email_confirmacao: 'thiago.igor.oliveira@gmail.com'
    },
    {
      id: 8180,
      fila: 2,
      status: 1,
      data_reserva: '2018-08-11T00:00:00-03:00',
      motivo: '',
      unidade: '0603',
      reservado_por: 'cond\u00f4mino',
      email_reserva: 'jullie_reis@hotmail.com',
      email_confirmacao: 'Utilidades Diego Rivera'
    },
    {
      id: 8213,
      fila: 1,
      status: 1,
      data_reserva: '2018-08-19T00:00:00-03:00',
      motivo: '',
      unidade: '0302',
      reservado_por: 'cond\u00f4mino',
      email_reserva: 'rayanevieira@hotmail.com',
      email_confirmacao: 'boletos@useadministradora.com.br'
    },
    {
      id: 8045,
      fila: 1,
      status: 1,
      data_reserva: '2018-08-25T00:00:00-03:00',
      motivo: '',
      unidade: '2804',
      reservado_por: 'administra\u00e7\u00e3o',
      email_reserva: 'b5fb59f842cf21f7cc238fcb2723dc60c3687d03',
      email_confirmacao: 'Utilidades Diego Rivera'
    },
    {
      id: 8349,
      fila: 1,
      status: -1,
      data_reserva: '2018-09-01T00:00:00-03:00',
      motivo: 'DESIST\u00caNCIA DO PROPRIET\u00c1RIO ',
      unidade: '0601',
      reservado_por: 'administra\u00e7\u00e3o',
      email_reserva: 'boletos@useadministradora.com.br',
      email_confirmacao: 'kessler Ravi'
    },
    {
      id: 8150,
      fila: 1,
      status: -1,
      data_reserva: '2018-09-02T00:00:00-03:00',
      motivo: 'Mudan\u00e7a de data para 01/09/2018.',
      unidade: '0601',
      reservado_por: 'administra\u00e7\u00e3o',
      email_reserva: 'mirtes@useadministradora.com.br',
      email_confirmacao: 'Thiago Rodrigo'
    }
  ]
};
export default (url, { method, body }) => {
  console.log(method + ' ' + url, body);
  switch (method + ' ' + url) {
    case 'POST http://localhost:3001/api/checkins':
      return {
        // todas essas informações abaixo devem vir do serviço
        checkin: new Date(),
        contratante: body.contratante.id
          ? body.contratante
          : {
              id: Math.floor(100000 * Math.random()),
              text: body.contratante.apartamento + ' - ' + body.contratante.nome
            },
        contratado: body.contratado.id
          ? body.contratado
          : {
              id: Math.floor(100000 * Math.random()),
              text:
                body.contratado.nome +
                (body.contratado.funcao ? ' - ' + body.contratado.funcao : '')
            }
      };
    case 'PUT http://localhost:3001/api/checkins':
      return {};
    case 'GET https://wesley.eti.br/api/context.php':
      return {
        roles: [
          'admin',
          'conselheiro',
          'morador',
          'porteiro*',
          'proprietario',
          'sindico*'
        ],
        apartamentos: [
          {
            unidade: '3301',
            role: 'morador'
          },
          {
            unidade: '3301',
            role: 'proprietario'
          }
        ]
      };
    case 'GET https://wesley.eti.br/api/reservas.php':
      return reservas;
    case 'POST https://wesley.eti.br/api/reservas.php':
      let newReserva = {
        id: 999,
        fila: 4,
        status: 0,
        data_reserva: body.data_reserva,
        motivo: '',
        unidade: body.unidade,
        reservado_por: 'Wesley',
        email_reserva: 'email@reserva',
        email_confirmacao: 'email@confirmacao'
      };
      reservas.list.unshift(newReserva);
      return newReserva;
    case 'PUT https://wesley.eti.br/api/reservas.php?id=999':
      return { ...reservas.list[0], status: 1 };
    case 'DELETE https://wesley.eti.br/api/reservas.php?id=999':
      return { ...reservas.list[0], ...body, status: -1 };
    default:
      return null;
  }
};



// WEBPACK FOOTER //
// ./src/utils/mocks.js